import React from "react"

import TableComponent from "./table-component"

class TableContainer extends React.Component {

	_getData = () => {
		var newRows = [], newData = []
		this.props.projectsData.rows.forEach(row => {
			if (!this.props.asResponsible || (row.theme.responsible && row.theme.responsible.id == this.props.currentUser.id)) {
				// MAIN THEMES
				if (!row.subtheme && !row.project) {
					row.isShown = (this.props.shownThemes.indexOf(row.theme.id) !== -1)
					newRows.push(row)
					newData.push(this.props.projectsData.data[row.index])
				} else {
					// SUB THEMES
					if (row.subtheme && !row.project) {
 						if (this.props.shownThemes.indexOf(row.theme.id) !== -1) {
							row.isShown = (this.props.shownThemes.indexOf(row.subtheme.id) !== -1)
							newRows.push(row)
							newData.push(this.props.projectsData.data[row.index])
						}
					}
					// PROJECTS
					if (row.project) {
						if (!row.subtheme) {
							if (this.props.shownThemes.indexOf(row.theme.id) !== -1) {
								newRows.push(row)
								newData.push(this.props.projectsData.data[row.index])
							}
						} else {
							if (this.props.shownThemes.indexOf(row.theme.id) !== -1 && this.props.shownThemes.indexOf(row.subtheme.id) !== -1) {
								newRows.push(row)
								newData.push(this.props.projectsData.data[row.index])
							}
						}
					}
				}
			}
		})

		const result = {
			rows: newRows,
			data: newData
		}
		return result
	}

	render() {

		const data = this._getData()
		return (
			<TableComponent
				consulted={this.props.consulted}
				tableDefinition={{rows: data.rows}}
				current_year={this.props.current_year}
				data={data.data}
				ppi={this.props.ppi}
				onChange={this.props.onChange}
				onProjectToggle={this.props.onProjectToggle}
				onCustomAction={this._handleCustomAction.bind(this)}
				previousYear={this.props.previousYear}
				currentUserType = {this.props.currentUserType}
			/>
		)
	}

	_handleCustomAction(type, data) {
		if (type == "toggle_investment_theme") {
			this.props.onThemeToggle(data)
		} else {
			this.props.onCustomAction(type, data)
		}
	}

}

export default TableContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/table-container.js